module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-autocomplete', _vm._b({
    attrs: {
      "chips": "",
      "dense": "",
      "small-chips": "",
      "deletable-chips": "",
      "clearable": "",
      "return-object": "",
      "multiple": _vm.multiple,
      "item-value": "id",
      "item-text": "text",
      "prepend-icon": "replay",
      "search-input": _vm.search,
      "label": _vm.label,
      "loading": _vm.request.loading,
      "persistent-hint": _vm.showHint,
      "hint": _vm.hintText,
      "items": _vm.formattedClients
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "click:prepend": _vm.fetch,
      "click:clear": _vm.clear,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, 'v-autocomplete', _vm.attrs, false)), _vm._v(" "), (_vm.formattedClients) ? _c('span', {
    staticClass: "ml-4 pl-2 caption"
  }, [_vm._v("\n    " + _vm._s(_vm.$tc('numresults', this.formattedClients.length, {
    count: this.formattedClients.length
  })))]) : _vm._e(), _vm._v(" "), (_vm.withQuickPick && _vm.multiple !== true && _vm.numClients > 0) ? _c('div', [_c('v-subheader', {
    staticClass: "pl-2 my-0 py-0 overline"
  }, [_vm._v("Quick pick")]), _vm._v(" "), _vm._l((_vm.formattedClients), function(cli) {
    return _c('v-chip', {
      key: cli.id,
      staticClass: "v-chip--x-small",
      staticStyle: {
        "min-width": "120px"
      },
      attrs: {
        "label": ""
      },
      on: {
        "click": function($event) {
          return _vm.setSelected(cli)
        }
      }
    }, [(_vm.selected && cli && _vm.selected.id === cli.id) ? _c('v-icon', {
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n      " + _vm._s(cli.first_name) + " " + _vm._s(cli.last_name) + "\n    ")], 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eba328f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/RelationshipPicker.vue
// module id = 1373
// module chunks = 9